<div class="app-content listings">
    @if (!(stats$ | async)) {
        <app-loading-indicator></app-loading-indicator>
    } @else {
        @if (stats$ | async; as stats) {
            @if (!stats.meta?.results) {
                <div class="empty-state">
                    <img
                        class="no-assessment"
                        id="img-empty-insights"
                        src="/assets/img/empty-insights.svg"
                        alt="No Stats to Display" />
                    <h2>No Statistics to Display</h2>
                    <p>
                        There are no assurance cases in the selected date range.
                    </p>
                </div>
            } @else {
                <div class="grid m-0 align-items-start">
                    <div class="col-12 lg:col-4 p-0 lg:pr-2">
                        <app-graphic-bars
                            class="w-full h-auto"
                            [title]="'Case Registry Status'"
                            [meta]="stats.data.caseRegistryStatus.meta"
                            [chartData]="stats.data.caseRegistryStatus.chartData">
                        </app-graphic-bars>
                    </div>

                    <div class="col-12 lg:col-4 p-0 mt-3 lg:mt-0 lg:px-1">
                        <app-graphic-single-bar
                            class="w-full h-auto"
                            [title]="'Case Registry Risk Distribution'"
                            [data]="stats.data.caseRegistryRiskDistribution.averageScores"
                            [meta]="stats.data.caseRegistryRiskDistribution.meta"
                            [chartData]="stats.data.caseRegistryRiskDistribution.chartData"
                            [scoreGroupsList]="stats.data.caseRegistryRiskDistribution.scoreGroupsList">
                        </app-graphic-single-bar>
                    </div>

                    <div class="col-12 lg:col-4 p-0 mt-3 lg:mt-0 lg:pl-2">
                        <app-graphic-pie
                            class="w-full h-auto"
                            [chartType]="'doughnut'"
                            [title]="'Monitoring Method'"
                            [meta]="stats.data.caseRegistryMonitoringMethods.meta"
                            [chartData]="stats.data.caseRegistryMonitoringMethods.chartData">
                        </app-graphic-pie>
                    </div>
                </div>
            }
        }
    }
</div>
